import React, { useContext } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import styles from '../../../../assets/styles/componentStyles/getStartedStyles/getStartedStyles.module.scss';
import LiveChat from '../../../../assets/images/getStarted/LiveChat.png';
import Calender from '../../../../assets/images/getStarted/Calender.png';
import GlobalButton from "../../../utility/globalButton/button";
import { UserContext, UserContextPayload } from "../../../../context/userContext";
import { isVendor } from "../../../../utils/constants";

const Footer = () => {

    const { setFlagShowScheduleCall } = useContext(UserContext) as UserContextPayload;

    const { vendorData, userDetail } = useContext(UserContext) as UserContextPayload;

  return (
    <Box className={styles.footerContainer}>
        <Typography variant="h6" className={styles.footerTitle}>
            Have any questions on how to get started?
        </Typography>

        <Typography variant="body1" className={styles.footerSubtitle}>
            We're ready to guide you through every step.
        </Typography>

        <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ width: "100%", marginTop: "12px" }}
        >
            {!isVendor(vendorData, userDetail) && (
                <GlobalButton
                    buttonText="Start a Live Chat"
                    className="borderedButtonStyle"
                    startIcon={<img src={LiveChat} alt="Live Chat" height={22} width={22} />} 
                    sx={{ width: "200px" }}
                    onClick={() => {
                        window.open(" https://api.whatsapp.com/send?phone=917861834273", "_blank");
                    }}
                />
            )}

            <GlobalButton
                buttonText="Schedule a Demo"
                className="borderedButtonStyle"
                startIcon={<img src={Calender} alt="Schedule Demo" height={22} width={22} />} 
                sx={{ width: "200px" }}
                onClick={() => {
                    setFlagShowScheduleCall(true);
                }}
            />
        </Stack>
    </Box>
  );
};

export default Footer;
